<template>
    <div class="w-5 h-5 relative">
        <div class="w-5 h-5 rounded-full absolute -translate-x-2/4 -translate-y-2/4 left-2/4 top-2/4 opacity-20" :class="[color, animation]"></div>
        <div class="rounded-full absolute -translate-x-2/4 -translate-y-2/4 left-2/4 top-2/4" :class="[color, innerSize]"></div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue'
    import { useLabelStore } from '@/stores/label'

    const labelStore = useLabelStore()

    const color = computed(() => {
        if (labelStore.labelHasStopped) return `bg-neutral-600`
        if (labelStore.labelIsActive) return `bg-green-500`
        else return `bg-neutral-300`
    })
    const animation = computed(() => labelStore.labelIsActive && `indicator-animation`)
    const innerSize = computed(() => (labelStore.labelIsActive ? `w-3 h-3` : `w-3 h-3`))
</script>

<style scoped>
    .indicator-animation {
        animation: grow 1.5s infinite ease-out;
    }
    @keyframes grow {
        from {
            scale: 0.5;
            opacity: 0.75;
        }
        to {
            scale: 1.05;
            opacity: 0.05;
        }
    }
</style>
